import ViewVotesManager from './ViewVotesManager';

export default class ViewVotesClient {

    constructor(toggleAllStateButtonClassName, checkBoxClassName) {
        this._viewVotesManager = new ViewVotesManager();

        this._toggleStateAllButtons = document.getElementsByClassName(toggleAllStateButtonClassName);
        this._checkBoxElemets = document.getElementsByClassName(checkBoxClassName);
        for (let i = 0; i < this._toggleStateAllButtons.length; i++) {
            this._toggleStateAllButtons[i].addEventListener('click', this.toggleAllState.bind(this), false);
        }
    }

    get manager() {
        return this._viewVotesManager;
    }

    getList(type) {
        return this._viewVotesManager.getList(type);
    }

    toggleAllState() {
        const isChecked = this._toggleStateAllButtons[0].dataset.isSelected === 'true';

        for (let i = 0; i < this._checkBoxElemets.length; i++) {
            this._checkBoxElemets[i].checked = !isChecked;
        }
        for (let i = 0; i < this._toggleStateAllButtons.length; i++) {
            const value = this._toggleStateAllButtons[i];
            value.dataset.isSelected = isChecked ? 'false' : 'true';
            value.textContent = isChecked ? '全件選択する' : '全件選択解除する';
        }
    }
}
